<template>
  <transition name="slide-fade" mode="out-in">
    <router-view />
  </transition>
</template>

<script>
export default {
  name: 'Crm',
  // 公共meta
  metaInfo() {
    return {
      // 默认title
      title: this.$route.meta.title ? `${this.$route.meta.title}` : '立林家服'
    }
  },
  created() {
    this.$toast.loading = msg => {
      return this.$toast({
        message: msg || '加载中...',
        forbidClick: true,
        duration: 0,
        className: 'animate-rotate',
        icon: require('img/crm/icon/loading.png')
      })
    }
    this.$toast.success = msg => {
      return this.$toast({
        message: msg,
        forbidClick: true,
        icon: require('img/crm/icon/passed.png')
      })
    }
    this.$toast.fail = msg => {
      return this.$toast({
        message: msg,
        forbidClick: true,
        icon: require('img/crm/icon/close.png')
      })
    }
  }
}
</script>

<style lang="less">
@import '../assets/style/base/crm.less';
// 路由过度
.slide-fade {
  &-enter {
    opacity: 0;
    transform: translateX(10px);
  }
  &-leave-to {
    opacity: 0;
    transform: translateX(-10px);
  }
  &-enter-active,
  &-leave-active {
    transition: all 0.2s ease;
  }
}
</style>
